import React from 'react';
import {ClickAwayListener, MenuList, Paper, Popper} from '@mui/material';

import ContextItems from './ContextItems';
import {useFileMenuContext} from './fileMenuContext';

export const ContextMenu = () => {
   //    const {data, anchorEl, handleClose} = useTreeViewContext();
   const {anchorEl, handleClose} = useFileMenuContext();
   const open = Boolean(anchorEl);

   return (
      <Popper
         anchorEl={anchorEl}
         open={open}
         placement="bottom-start"
         role={undefined}
         sx={(theme) => ({zIndex: theme.zIndex.modal})}
         // disablePortal
         // transition
      >
         {/* Produced a glitches because of stopImmediatePropagation on open {({TransitionProps}) => (
              <Grow
                 {...TransitionProps}
                 style={{
                    transformOrigin: 'top',
                 }}
              > */}
         <Paper
            sx={(theme) => ({backgroundColor: theme.palette.grey[50], color: 'black'})}
            color="default"
         >
            <ClickAwayListener onClickAway={handleClose}>
               <MenuList autoFocusItem={open} variant="menu">
                  <ContextItems />
               </MenuList>
            </ClickAwayListener>
         </Paper>
         {/* </Grow>
           )} */}
      </Popper>
   );
};
